abstract class IntervalTimeout {
    private callback: () => void;
    private time: number;
    private id: undefined | NodeJS.Timeout;

    constructor(
        callback: IntervalTimeout['callback'],
        time: IntervalTimeout['time']
    ) {
        this.callback = () => {
            this.id = undefined;
            callback();
        };
        this.time = time;
        this.id = undefined;
    }

    setTime(time: number): this {
        this.time = time;
        if (this.running())
            this.restart();
        return this;
    }

    setCallback(callback: () => void): this {
        this.callback = () => {
            this.id = undefined;
            callback();
        };
        if (this.running())
            this.restart();
        return this;
    }

    start(): this {
        if (!this.running())
            this.id = this.set(this.callback, this.time);
        return this;
    }

    stop(): this {
        if (this.running()) {
            this.clear(this.id!);
            this.id = undefined;
        }
        return this;
    }

    running() {
        return this.id !== undefined;
    }

    restart() {
        if (this.running())
            this.stop();
        this.start();
    }

    protected abstract set(f: VoidFunction, ms: number): NodeJS.Timeout;

    protected abstract clear(id: NodeJS.Timeout): void;
}

export class Timeout extends IntervalTimeout {
    constructor(
        callback: IntervalTimeout['callback'],
        time: IntervalTimeout['time'],
    ) {
        super(callback, time);
    }

    protected set(f: VoidFunction, ms: number) {
        return setTimeout(f, ms);
    }

    protected clear(id: NodeJS.Timeout) {
        return clearTimeout(id);
    }
}

export class Interval extends IntervalTimeout {
    constructor(
        callback: IntervalTimeout['callback'],
        time: IntervalTimeout['time'],
    ) {
        super(callback, time);
    }

    protected set(f: VoidFunction, ms: number) {
        return setInterval(f, ms);
    }

    protected clear(id: NodeJS.Timeout) {
        return clearInterval(id);
    }
}
